// import { createSlice } from "@reduxjs/toolkit";

// const ProcedureSlice = createSlice({
//   name: "Procedure",
//   initialState: {
//     type: "", // 'virtual' or 'physical'
//   },
//   reducers: {
//     setProcedureType: (state, action) => {
//       state.type = action.payload;
//     },
//     resetProcedureType: (state) => {
//       state.type = state.initialState;
//     },
//   },
// });

// export const { setProcedureType, resetProcedureType } = ProcedureSlice.actions;
// export default ProcedureSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL from "../../BaseURL/baseURL";
import axiosInstance from "../../BaseURL/axiosInstance";

// Thunk for API call
export const updateAppointmentType = createAsyncThunk(
  "Procedure/updateAppointmentType",
  async ({ pde, appointmentType }, { rejectWithValue }) => {
    try {
      //debugger;
      const response = await axiosInstance.put(
        `/CompleteProperty/updateAppointmentType`,
        {
          pdE_ID: pde,
          appointmentType: appointmentType,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const modifyAppointmentType = createAsyncThunk(
  "Procedure/modifyAppointmentType",
  async ({ pdeMod, appointmentType }, { rejectWithValue }) => {
    try {
      //debugger;
      // const response = await axios.put(
      //   `${API_BASE_URL}/CompleteProperty/updateAppointmentType`,
      //   {
      //     pdE_ID: pdeMod,
      //     appointmentType: appointmentType,
      //   }
      // );
      const response = await axiosInstance.put(
        `/CompleteProperty/updateAppointmentType`,
        {
          pdE_ID: pdeMod,
          appointmentType: appointmentType,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const ProcedureSlice = createSlice({
  name: "Procedure",
  initialState: {
    appointmentType: "", // 'virtual' or 'physical'
    status: "idle",
    error: null,
  },
  reducers: {
    setProcedureType: (state, action) => {
      state.appointmentType = action.payload;
    },
    resetProcedureType: (state) => {
      state.appointmentType = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAppointmentType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateAppointmentType.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Handle success if needed
      })
      .addCase(updateAppointmentType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(modifyAppointmentType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(modifyAppointmentType.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Handle success if needed
      })
      .addCase(modifyAppointmentType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { setProcedureType, resetProcedureType } = ProcedureSlice.actions;
export default ProcedureSlice.reducer;
